import {ZodTypeAny, ZodOptional, ZodNullable} from 'zod';

export function unwrapField(field: ZodTypeAny) {
  let unwrappedField = field;
  let isOptional,
    isNullable = false;

  while (unwrappedField instanceof ZodOptional || unwrappedField instanceof ZodNullable) {
    if (unwrappedField instanceof ZodOptional) {
      isOptional = true;
      unwrappedField = unwrappedField.unwrap();
    } else if (unwrappedField instanceof ZodNullable) {
      isNullable = true;
      unwrappedField = unwrappedField.unwrap();
    }
  }

  return {unwrappedField, isOptional, isNullable};
}
